var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 text-no-wrap",attrs:{"headers":_vm.Head,"items":_vm.data,"item-key":"i_ser","single-select":"","height":"200px","max-height":"200px"},on:{"click:row":_vm.rowSelect,"dblclick:row":_vm.enterSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }